import React from "react";
import { createRoot } from 'react-dom/client'
import SearchGallery from "./Components/SearchGallery";

const SearchGalleryElement = document.getElementById('inventory');

const root = createRoot(SearchGalleryElement);

root.render(<SearchGallery inventoryList={inventory} pageContext={context} facets={facets}/>);